export enum PolicyLevel {
  WORKSPACE = 'workspace',
  GROUP = 'group',
  USER = 'user',
  SAT = 'sat',
}

export enum UserRole {
  ADMIN = 'admin',
  MEMBER = 'member',
}

export enum PermissionResourceType {
  DESTINATION = 'destination',
  EVENT_STREAM = 'event-stream',
  RETL = 'retl',
  TABLE = 'table',
  AUDIENCE = 'audience',
  SQL_MODEL = 'sql-model',
  DATA_CATALOG = 'data-catalog',
  TRACKING_PLAN = 'tracking-plan',
  TRANSFORMATION = 'transformation',
  TRANSFORMATION_LIBRARY = 'transformation-library',
  PROFILES_PROJECT = 'profiles-project',
  RETRY_SYNC = 'retry-sync',
  ALERT_OVERRIDE = 'alert-override',
  BOT_MANAGEMENT = 'bot-management',
  CREDENTIAL_STORE = 'credentials',
  DATA_GRAPH = 'data-graph',
}

export enum PermissionActionType {
  EDIT = 'edit',
  CONNECT = 'connect',
  CREATE_DELETE = 'create-delete',
  PII_LIVE_EVENTS = 'pii-live-events',
  PII_FAILURE_SAMPLES = 'pii-failure-samples',
  PII_ACCESS_DATA = 'pii-access-data',
}

export enum PermissionActionInput {
  LIST = 'array',
  TOGGLE = 'boolean',
}

export enum InvitationStatus {
  PENDING = 'pending',
  EXPIRED = 'expired',
  ACCEPTED = 'accepted',
}

export enum ServiceAccessTokenLevel {
  ORGANIZATION = 'organization',
  WORKSPACE = 'workspace',
}

export enum AMMigrationState {
  INITIAL = 'initial',
  IMPORTING = 'importing',
  IMPORTED = 'imported',
  DEPLOYING = 'deploying',
  DEPLOYED = 'deployed',
  RESETTING = 'resetting',
}

export const swrConfigDefaults = {
  dedupingInterval: 60 * 1000, // 1 min, default is 2s
  shouldRetryOnError: true, // default is true
  errorRetryInterval: 1000, // 1s, default is 5s
  errorRetryCount: 2, // no default
  revalidateOnFocus: true, // default is true
};

export const EVENT_BLOCKING_API_URLS = {
  workspaceBlockList: '/blocking-list',
  blockLists: '/blocking-lists',
  workspaceBlockListEvents: '/blocking-list/events',
  workspaceBlockListSingleEvent: (eventId: string) => `/blocking-list/events/${eventId}`,
  sourceBlockedEvents: (sourceId: string) => `/sources/${sourceId}/blockedEvents`,
};

export enum BlockListResourceType {
  WORKSPACE = 'workspace',
  SOURCE = 'source',
}

export enum PLAN_EVENT_VOLUME_BAND {
  FREE = 'FREE',
  STARTER_1M = 'STARTER_1M',
  STARTER_3M = 'STARTER_3M',
  STARTER_7M = 'STARTER_7M',
  STARTER_10M = 'STARTER_10M',
}

export enum EVENT_USAGE_STATUS {
  NORMAL = 'normal',
  WARNING_85_PERCENT = 'warning_85_percent',
  WARNING_90_PERCENT = 'warning_90_percent',
  WARNING_95_PERCENT = 'warning_95_percent',
  LIMIT_EXCEEDED = 'limit_exceeded',
  AT_RISK_2_MONTHS = 'at_risk_2_months',
  AT_RISK_3_MONTHS = 'at_risk_3_months',
  EVENTS_STOPPED = 'events_stopped',
}

export enum TEST_RUN_STATUS {
  PASS = 'pass',
  FAIL = 'fail',
  ERROR = 'error',
}

export enum MODEL_TYPE {
  ENTITY = 'entity',
  EVENT = 'event',
}

export enum RELATIONSHIP_TYPE {
  ONE_TO_ONE = 'one-to-one',
  ONE_TO_MANY = 'one-to-many',
  MANY_TO_ONE = 'many-to-one',
}

export enum MODEL_VALIDATION_RULE {
  TABLE_EXISTS = 'model/table-exists',
  PRIMARY_ID_EXISTS = 'model/primaryid-exists',
  PRIMARY_ID_UNIQUE_CONSTRAINT_EXISTS = 'model/primaryid-unique-constraint-exists',
  NO_CIRCULAR_DEPENDENCIES = 'model/no-circular-dependencies',
  TABLE_NOT_EMPTY = 'model/table-not-empty',
  TABLE_HAS_RECENT_DATA = 'model/table-has-recent-data',
}

export enum RELATIONSHIP_VALIDATION_RULE {
  SOURCE_JOIN_KEY_EXISTS = 'relationship/source-join-key-exists',
  TARGET_JOIN_KEY_EXISTS = 'relationship/target-join-key-exists',
  JOIN_KEYS_TYPE_MATCH = 'relationship/join-keys-type-match',
}

export enum VALIDATION_SEVERITY {
  ERROR = 'error',
  WARNING = 'warning',
}

export enum SyncRunType {
  INCREMENTAL = 'incremental',
  FULL = 'full',
}

export enum SyncRunTrigger {
  MANUAL = 'manual',
  SCHEDULED = 'scheduled',
}

export enum TrialStatus {
  IN_PROGRESS = 'in_progress',
  GRACE_PERIOD = 'grace_period',
  EXPIRED = 'expired',
  COMPLETED = 'completed',
}

export enum PlanNameType {
  ENTERPRISE = 'Enterprise',
  STARTER = 'Starter',
  FREE_TIER = 'Free Tier',
  PRO = 'Pro',
  OPEN_SOURCE_PLAN = 'Open source plan',
  GROWTH = 'Growth',
}
